// All programme times are naive local times in Europe/Lisbon ("YYYY-MM-DDTHH:mm").
const TZ = "Europe/Lisbon";
const DAYS = ["domingo", "segunda-feira", "terça-feira", "quarta-feira", "quinta-feira", "sexta-feira", "sábado"];
const MONTHS = ["janeiro", "fevereiro", "março", "abril", "maio", "junho", "julho", "agosto", "setembro", "outubro", "novembro", "dezembro"];

export function lisbonNow() {
  return new Intl.DateTimeFormat("sv-SE", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false })
    .format(new Date()).replace(" ", "T").slice(0, 16);
}

const asUTC = (s) => new Date(`${s}:00Z`);
export const addMinutes = (s, m) => new Date(asUTC(s).getTime() + m * 60000).toISOString().slice(0, 16);
export const endOf = (a) => addMinutes(a.start, a.duration || 60);
export const timeOf = (s) => (s || "").slice(11, 16).replace(":", "h");
export const dayOf = (s) => (s || "").slice(0, 10);

export function fmtDay(dateStr, withWeekday = true) {
  if (!dateStr) return "";
  const [y, m, d] = dateStr.slice(0, 10).split("-").map(Number);
  const wd = new Date(Date.UTC(y, m - 1, d)).getUTCDay();
  return `${withWeekday ? DAYS[wd] + ", " : ""}${d} de ${MONTHS[m - 1]}${withWeekday ? "" : " de " + y}`;
}

export const fmtDuration = (m) => (m >= 60 ? `${Math.floor(m / 60)}h${m % 60 ? String(m % 60).padStart(2, "0") : ""}` : `${m} min`);

export const isLive = (a, now) => a.start <= now && now < endOf(a);
export const overlaps = (a, b) => a.id !== b.id && a.start < endOf(b) && b.start < endOf(a);

function toUTCStamp(local) {
  const guess = asUTC(local);
  const shown = new Intl.DateTimeFormat("sv-SE", { timeZone: TZ, year: "numeric", month: "2-digit", day: "2-digit", hour: "2-digit", minute: "2-digit", hour12: false }).format(guess).replace(" ", "T");
  const offset = asUTC(shown).getTime() - guess.getTime();
  return new Date(guess.getTime() - offset).toISOString().replace(/[-:]/g, "").slice(0, 15) + "Z";
}

const esc = (s) => (s || "").replace(/[\\,;]/g, (c) => "\\" + c).replace(/\n/g, "\\n");

export function buildICS(acts, placeOf) {
  const lines = ["BEGIN:VCALENDAR", "VERSION:2.0", "PRODID:-//AASPS//Feira de Saude e Bem-Estar//PT", "CALSCALE:GREGORIAN"];
  acts.forEach((a) => {
    lines.push("BEGIN:VEVENT", `UID:${a.id}@feira-saude-bem-estar`, `DTSTAMP:${new Date().toISOString().replace(/[-:]/g, "").slice(0, 15)}Z`,
      `DTSTART:${toUTCStamp(a.start)}`, `DTEND:${toUTCStamp(endOf(a))}`, `SUMMARY:${esc(a.title)}`,
      `LOCATION:${esc(placeOf(a))}`, `DESCRIPTION:${esc(a.summary || "")}`, `URL:${window.location.origin}/atividade/${a.slug}`, "END:VEVENT");
  });
  lines.push("END:VCALENDAR");
  return lines.join("\r\n");
}

export function downloadICS(acts, placeOf, name = "feira-saude-bem-estar") {
  const blob = new Blob([buildICS(acts, placeOf)], { type: "text/calendar;charset=utf-8" });
  const a = document.createElement("a");
  a.href = URL.createObjectURL(blob);
  a.download = `${name}.ics`;
  a.click();
  setTimeout(() => URL.revokeObjectURL(a.href), 2000);
}
